WAU.Quickshop = {
	cache: new Map(),
  cardQtyBound: false,
  init: function init() {

    var selectors = {
      quickviewButton: '.js-quickview-trigger'
    }

		// Remove section contents
		if ( document.getElementById('quickshopTemplate') ) {
			document.getElementById('quickshopTemplate').innerHTML = '';
		}

    WAU.Quickshop.bindCardQtyControls();

    // Init on click event for buttons
    document.querySelectorAll(selectors.quickviewButton).forEach((button, i) => {

      button.addEventListener('click', function(event) {
        event.preventDefault();

        if (this.hasAttribute('data-direct-add')) {
          WAU.Quickshop.directAdd(this);
          return;
        }

				event.target.classList.add('loading-quickshop');

				var productUrl = this.dataset.productUrl,
						productUrl = WAU.Quickshop.cleanUrl(productUrl, 'variant');

				let singleVariant = event.target.hasAttribute('data-quick-add');

				const loader = new WAU.Helpers.scriptLoader();

        if ( this.dataset.hasModel )loader.load([jsAssets.productModel]).finally(() => {});
        if ( this.dataset.hasVideo )loader.load([jsAssets.productVideo]).finally(() => {});
				if ( this.dataset.productComplementaryProducts )loader.load([jsAssets.productComplementaryProducts]).finally(() => {});
        if ( this.dataset.productPickupAvailability )loader.load([jsAssets.productPickupAvailability]).finally(() => {});

				loader.load([jsAssets.flickity]).finally(() => {
					loader.load([jsAssets.product]).finally(() => {
						WAU.Quickshop.getTemplate(productUrl, singleVariant, event.target);
					});
				});

      });
    });

		// Prefetch Quickviews
    document.querySelectorAll(selectors.quickviewButton).forEach(button => {
      if (button.hasAttribute('data-direct-add')) return;
      if (!'IntersectionObserver' in window) return;
      const observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(button);
        WAU.Quickshop.prefetchQuickview(button);
      },
      {
        rootMargin: '0px 0px 200px 0px',
      });
      observer.observe(button);
    });

    WAU.Quickshop.hydrateCardSteppersFromCart();

		// Open placeholder product on edit
		document.addEventListener("shopify:section:select", function(event) {
		  if (event.target.id != 'shopify-section-quickshop') return false;

			WAU.Quickshop.getOnboard();

		});
  },
  getCardActionsRoot: function getCardActionsRoot(el) {
    return el ? el.closest('.product-loop__cart-actions') : null;
  },
  getCardStepper: function getCardStepper(root) {
    return root ? root.querySelector('.js-card-qty-stepper') : null;
  },
  getCardAddButton: function getCardAddButton(root) {
    return root ? root.querySelector('.js-quickview-trigger[data-direct-add]') : null;
  },
  findCartLineByVariantId: function findCartLineByVariantId(cart, variantId) {
    if (!cart || !cart.items) return null;
    var match = null;
    cart.items.forEach(function(item) {
      if (item.variant_id === variantId) {
        match = item;
      }
    });
    return match;
  },
  showCardStepperForLine: function showCardStepperForLine(cartLine) {
    if (!cartLine) return;

    document.querySelectorAll('.js-card-qty-stepper[data-variant-id="' + cartLine.variant_id + '"]').forEach(function(stepper) {
      var root = WAU.Quickshop.getCardActionsRoot(stepper);
      var addBtn = WAU.Quickshop.getCardAddButton(root);
      var qtyValue = stepper.querySelector('.js-card-qty-value');

      stepper.dataset.itemKey = cartLine.key;
      if (qtyValue) qtyValue.textContent = cartLine.quantity;
      stepper.hidden = false;
      if (root) root.classList.add('is-in-cart');
      if (addBtn) addBtn.hidden = true;
    });
  },
  hideCardStepperForVariant: function hideCardStepperForVariant(variantId) {
    document.querySelectorAll('.js-card-qty-stepper[data-variant-id="' + variantId + '"]').forEach(function(stepper) {
      var root = WAU.Quickshop.getCardActionsRoot(stepper);
      var addBtn = WAU.Quickshop.getCardAddButton(root);

      stepper.hidden = true;
      stepper.dataset.itemKey = '';
      stepper.classList.remove('is-busy');
      stepper.setAttribute('aria-busy', 'false');
      if (root) root.classList.remove('is-in-cart');
      if (addBtn) {
        addBtn.hidden = false;
        addBtn.classList.remove('loading-quickshop', 'js-quick-adding');
      }
    });
  },
  hydrateCardSteppersFromCart: function hydrateCardSteppersFromCart(cart) {
    var promise = cart ? Promise.resolve(cart) : WAU.ThemeCart.getCart();

    return promise.then(function(cartState) {
      var linesByVariant = {};

      (cartState.items || []).forEach(function(item) {
        linesByVariant[item.variant_id] = item;
      });

      document.querySelectorAll('.js-card-qty-stepper').forEach(function(stepper) {
        var variantId = parseInt(stepper.dataset.variantId, 10);
        var line = linesByVariant[variantId];

        if (line) {
          WAU.Quickshop.showCardStepperForLine(line);
        } else {
          WAU.Quickshop.hideCardStepperForVariant(variantId);
        }
      });

      return cartState;
    }).catch(function(error) {
      console.log(error);
    });
  },
  setCardStepperBusy: function setCardStepperBusy(stepper, busy) {
    if (!stepper) return;

    stepper.setAttribute('aria-busy', busy ? 'true' : 'false');
    stepper.classList.toggle('is-busy', busy);
    stepper.querySelectorAll('.js-card-qty-down, .js-card-qty-up').forEach(function(btn) {
      btn.disabled = busy;
    });
  },
  showCardQtyError: function showCardQtyError(stepper, config, limitOverride) {
    if (!stepper || !config || !WAU.AjaxCart) return;

    var root = WAU.Quickshop.getCardActionsRoot(stepper) || stepper.parentNode;
    if (!root) return;

    var limit = limitOverride !== undefined ? limitOverride : stepper.dataset.limit;
    var existing = root.querySelector('.product-loop__qty-error');
    if (existing) existing.remove();

    var note = document.createElement('div');
    note.className = 'product-loop__qty-error note note-error';
    note.setAttribute('role', 'alert');
    note.innerHTML = '<p class="a-center lh3">' + WAU.AjaxCart.stockLimitMessageHtml(config, limit) + '</p>';
    root.appendChild(note);

    setTimeout(function() {
      if (note.parentNode) note.parentNode.removeChild(note);
    }, 4000);
  },
  getCartConfig: function getCartConfig() {
    var cartConfigEl = document.getElementById('cart-config');
    if (!cartConfigEl) return null;
    return JSON.parse(cartConfigEl.innerHTML || '{}');
  },
  bindCardQtyControls: function bindCardQtyControls() {
    if (WAU.Quickshop.cardQtyBound) return;
    WAU.Quickshop.cardQtyBound = true;

    document.addEventListener('click', function(event) {
      var downBtn = event.target.closest('.js-card-qty-down');
      var upBtn = event.target.closest('.js-card-qty-up');
      if (!downBtn && !upBtn) return;

      event.preventDefault();

      var stepper = (downBtn || upBtn).closest('.js-card-qty-stepper');
      if (!stepper || stepper.hidden) return;

      var itemKey = stepper.dataset.itemKey;
      if (!itemKey) return;

      var config = WAU.Quickshop.getCartConfig();
      if (!config) return;

      var qtyValue = stepper.querySelector('.js-card-qty-value');
      var currentQty = parseInt(qtyValue ? qtyValue.textContent : '0', 10) || 0;
      var delta = upBtn ? 1 : -1;
      var limit = stepper.dataset.limit;

      function readQty() {
        var el = stepper.querySelector('.js-card-qty-value');
        return parseInt(el ? el.textContent : '0', 10) || 0;
      }

      var newQty = currentQty + delta;

      if (newQty < 0) return;

      var stockLimit = WAU.AjaxCart.parseInventoryLimit(limit);
      if (stockLimit !== null && newQty > stockLimit) {
        WAU.Quickshop.showCardQtyError(stepper, config);
        return;
      }

      if (qtyValue) {
        qtyValue.textContent = newQty;
      }

      if (newQty === 0) {
        WAU.ThemeCart.updateItem(itemKey, { quantity: 0 }).then(function(cart) {
          WAU.AjaxCart._lastCartSnapshot = cart;
          WAU.AjaxCart.patchCartFromJson(cart, config);
          return WAU.AjaxCart.updateView(config, cart);
        }).then(function() {
          return WAU.Quickshop.hydrateCardSteppersFromCart();
        }).catch(function(error) {
          console.log(error);
        });
        return;
      }

      WAU.AjaxCart.scheduleCardQuantityUpdate(itemKey, stepper, config, readQty);
    });
  },
	prefetchQuickview: async function({dataset}) {
    const { productUrl } = dataset;
    const cleanUrl = WAU.Quickshop.cleanUrl(productUrl);

    if (!WAU.Quickshop.cache.has(cleanUrl)) {
      const response = await fetch(productUrl);
      htmlText = await response.text();
      WAU.Quickshop.cache.set(cleanUrl, htmlText);
    }
  },
  formatTemplate: function formatTemplate(response) {
		const html = new DOMParser()
      .parseFromString(response, 'text/html')
      .getElementById('quickshopTemplate').innerHTML;

    return html;
  },
  showModal: function showModal(trigger) {
		trigger.setAttribute('data-wau-modal-target', 'quickview');
		trigger.classList.add('js-modal-open');

		WAU.Modal._openByName("modal-quickview");
  },
  hideModal: function hideModal() {
		document.querySelector('.js-quickview-content').innerHTML = '';

    WAU.Modal._closeByName("modal-quickview");
  },
	showDrawer: function showDrawer(trigger) {
		trigger.setAttribute('data-wau-slideout-target', 'quickview');
		trigger.setAttribute('data-slideout-direction', 'right');
		trigger.classList.add('js-slideout-open');

		WAU.Slideout._openByName("slideout-quickview");
	},
	hideDrawer: function hideDrawer() {
		document.querySelector('.js-quickview-content').innerHTML = '';

		WAU.Slideout._closeByName("slideout-quickview");
	},
  cleanUrl: function cleanUrl(url, key) {
    return url.split('?')[0] + '?view=quick';
  },
  directAdd: function directAdd(button) {
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    var config = WAU.Quickshop.getCartConfig();
    if (!config) return;

    var root = WAU.Quickshop.getCardActionsRoot(button);
    var stepper = WAU.Quickshop.getCardStepper(root);
    var stockLimit = stepper && WAU.AjaxCart
      ? WAU.AjaxCart.parseInventoryLimit(stepper.dataset.limit)
      : null;

    var plusIcon = button.querySelector('.quickview-trigger--plus');
    var loadingIcon = button.querySelector('.quickview-trigger--loading');

    function resetButton() {
      button.classList.remove('loading-quickshop', 'js-quick-adding');
      if (loadingIcon) WAU.Helpers.fadeOut(loadingIcon);
      if (plusIcon) WAU.Helpers.fadeIn(plusIcon, 'inline-block');
    }

    function handleAddError(error) {
      resetButton();
      if (!stepper || error.status != 422) {
        console.log(error);
        return;
      }

      function showStockMessage(limitValue) {
        WAU.Quickshop.showCardQtyError(stepper, config, limitValue);
      }

      if (typeof error.json === 'function') {
        error.json().then(function(data) {
          var shopifyMsg = data && data.description;
          if (typeof shopifyMsg === 'string' && shopifyMsg.trim()) {
            var rootEl = WAU.Quickshop.getCardActionsRoot(stepper) || stepper.parentNode;
            var existing = rootEl.querySelector('.product-loop__qty-error');
            if (existing) existing.remove();
            var note = document.createElement('div');
            note.className = 'product-loop__qty-error note note-error';
            note.setAttribute('role', 'alert');
            note.innerHTML = '<p class="a-center lh3"><b>' + config.cart_error + '</b>&nbsp;&nbsp;' + shopifyMsg + '</p>';
            rootEl.appendChild(note);
            setTimeout(function() {
              if (note.parentNode) note.parentNode.removeChild(note);
            }, 4000);
          } else {
            showStockMessage(stepper.dataset.limit);
          }
        }).catch(function() {
          showStockMessage(stepper.dataset.limit);
        });
      } else {
        showStockMessage(stepper.dataset.limit);
      }
    }

    function runAdd() {
      button.classList.add('loading-quickshop', 'js-quick-adding');
      if (plusIcon) WAU.Helpers.fadeOut(plusIcon);
      if (loadingIcon) WAU.Helpers.fadeIn(loadingIcon, 'inline-block');

      WAU.ThemeCart.addItem(variantId, { quantity: 1 }).then(function() {
        return WAU.ThemeCart.getCart();
      }).then(function(cart) {
        WAU.AjaxCart.patchCartFromJson(cart, config);
        var line = WAU.Quickshop.findCartLineByVariantId(cart, variantId);
        if (line) WAU.Quickshop.showCardStepperForLine(line);
        return WAU.AjaxCart.updateView(config, cart);
      }).then(function() {
        button.classList.remove('loading-quickshop', 'js-quick-adding');
        if (loadingIcon) WAU.Helpers.fadeOut(loadingIcon);
      }).catch(handleAddError);
    }

    if (stockLimit === null) {
      runAdd();
      return;
    }

    WAU.ThemeCart.getCart().then(function(cart) {
      var line = WAU.Quickshop.findCartLineByVariantId(cart, variantId);
      var inCart = line ? line.quantity : 0;
      if (inCart + 1 > stockLimit) {
        WAU.Quickshop.showCardQtyError(stepper, config, stockLimit);
        return;
      }
      runAdd();
    }).catch(function() {
      runAdd();
    });
  },
	getTemplate: async function getTemplate(url, singleVariant, trigger) {
		try {
			let htmlText;

      // Use cached HTML if available
      if (WAU.Quickshop.cache.has(url)) {
        htmlText = WAU.Quickshop.cache.get(url);
      } else {
        const response = await fetch(url);
        htmlText = await response.text();
      }

			let content = WAU.Quickshop.formatTemplate(htmlText);

			// Replace content
			document.querySelector('.js-quickview-content').innerHTML = content;

			// Set context
			const context = document.getElementById('quickview-form');

			// Load product js function
			Product(context);

			// Load Payment Buttons
			if (context.querySelector('.js-quickview-wrapper')) {
				if (
					context.querySelector('.js-quickview-wrapper').dataset.paymentButton == 'true' &&
					Shopify.PaymentButton
				) {
					Shopify.PaymentButton.init();
				}
			}

			// Trigger event for add to cart
			if (context.querySelector('.js-ajax-submit')) {
				context.querySelector('.js-ajax-submit').addEventListener('click', function (e) {
					e.preventDefault();

					var addToCartForm = this.closest('form');

					let cartConfig = document.getElementById('cart-config');
					if (!cartConfig) return false;
					cartConfig = JSON.parse(cartConfig.innerHTML || '{}');

					WAU.AjaxCart.addToCart(addToCartForm, null, cartConfig, true, false);

					return false;
				});
			}

			let type = context.dataset.quickshopType,
				quickAdd = context.dataset.quickshopAdd === 'true';

			if (quickAdd === true && singleVariant === true) {
				// Add to cart if single variant and quick add is enabled
				var addToCartForm = context.querySelector('.js-product-form-quickshop');

				let cartConfig = document.getElementById('cart-config');
				if (!cartConfig) return false;
				cartConfig = JSON.parse(cartConfig.innerHTML || '{}');

				trigger.classList.add('js-quick-adding');

				WAU.AjaxCart.addToCart(addToCartForm, null, cartConfig, true, true, trigger);

				trigger.classList.remove('loading-quickshop');
			} else {
				// Open quick shop
				if (type === 'modal') {
					WAU.Quickshop.showModal(trigger);
				} else {
					WAU.Quickshop.showDrawer(trigger);
				}
				trigger.classList.remove('loading-quickshop');
			}
		} catch (error) {
			console.log(error);
		}
	},
	getOnboard: function getOnboard() {

		const template = document.querySelector('.js-quickview-onboard');

		if (!template) {
			console.error('Error. No quickview onboard element.');
			return false;
		}

		const content = template.content.cloneNode(true);

		if (!content) {
			console.error('Error. No quickview onboard content.');
			return false;
		}

		const quickviewContent = document.querySelector('.js-quickview-content');

		if (!quickviewContent) {
			console.error('Error. No quickview content element.');
			return false;
		}

		quickviewContent.innerHTML = '';

		quickviewContent.appendChild(content);

		let type = template.dataset.quickshopType,
				trigger = document.querySelector('.js-quickview-onboard-trigger');

		if ( type == 'modal' ) {

			if (document.body.classList.contains('slideout-right--open')) document.body.classList.remove('slideout-right--open');
			WAU.Quickshop.showModal(trigger);

		} else {
			if (document.body.classList.contains('modal--open')) document.body.classList.remove('modal--open');
			WAU.Quickshop.showDrawer(trigger);
		}

	}
}

document.addEventListener('DOMContentLoaded', function() {
  WAU.Quickshop.init();
});

document.addEventListener('shopify:section:select', function(event){
  WAU.Quickshop.init();
});
